/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { useEffect, useMemo } from "react";
import { createPortal } from "react-dom";

interface IPortalProps {
  children?: React.ReactNode;
  portalRootId: string;
}

export const Portal = ({ children, portalRootId }: IPortalProps) => {
  const mountPoint = useMemo(() => {
    let _mountPoint = document.getElementById(portalRootId);
    if (!_mountPoint) {
      _mountPoint = document.createElement("div");
      _mountPoint.id = portalRootId;
    }
    return _mountPoint;
  }, [portalRootId]);

  useEffect(() => {
    document.body.appendChild(mountPoint);
    return () => {
      document.body.removeChild(mountPoint);
    };
  }, [mountPoint]);

  return createPortal(children, mountPoint);
};
